// Proper variety names are intentionally language-neutral and must never be translated.
export const NEW_VARIETIES = [
  {
    id: "crimea",
    name: "CRIMEA",
    image: "/images/new-varieties/crimea_bud.webp",
    descriptionEn:
      "A luminous carnation with creamy petals and a warm apricot center, designed to bring softness and personality to refined floral compositions.",
    descriptionRu:
      "Светлая гвоздика с кремовыми лепестками и тёплым абрикосовым центром, которая придаёт изысканным композициям мягкость и характер.",
    noteEn: "Warm two-tone carnation with a delicate glow.",
    noteRu: "Тёплая двухцветная гвоздика с деликатным сиянием.",
  },
  {
    id: "corvette",
    name: "CORVETTE",
    image: "/images/new-varieties/corvette.webp",
    descriptionEn:
      "A fresh pink carnation with expressive movement and volume, ideal for bouquets that call for a youthful and elegant accent.",
    descriptionRu:
      "Свежая розовая гвоздика с выразительным объёмом и движением лепестков, идеально подходящая для букетов с молодым и элегантным акцентом.",
    noteEn: "Soft pink texture with generous petal volume.",
    noteRu: "Мягкая розовая текстура и щедрый объём лепестков.",
  },
  {
    id: "cocuy",
    name: "COCUY",
    image: "/images/new-varieties/cocuy.webp",
    descriptionEn:
      "Featuring uniquely white toned petals with a subtle yet distinctive color presence. This carnation adds depth and originality to creative floral arrangements.",
    descriptionRu:
      "Отличается белоснежными лепестками с деликатным, но заметным цветовым акцентом. Эта гвоздика добавляет глубину и оригинальность креативным цветочным композициям.",
    noteEn: "Clean white presence with refined dimension.",
    noteRu: "Чистый белый оттенок и изящная глубина формы.",
  },
  {
    id: "zafiro",
    name: "ZAFIRO",
    image: "/images/new-varieties/zafiro.webp",
    descriptionEn:
      "An intense fuchsia carnation with rich texture and modern character, created for statement arrangements that need color and confidence.",
    descriptionRu:
      "Насыщенная фуксиевая гвоздика с богатой текстурой и современным характером для выразительных композиций, которым нужны цвет и уверенность.",
    noteEn: "Deep fuchsia impact with contemporary energy.",
    noteRu: "Глубокая фуксия с современной выразительностью.",
  },
  {
    id: "virgilio",
    name: "VIRGILIO",
    image: "/images/new-varieties/virgilio.webp",
    descriptionEn:
      "A powerful red carnation with sculptural petal structure and strong visual presence, suited for premium romantic and celebratory work.",
    descriptionRu:
      "Яркая красная гвоздика со скульптурной формой лепестков и сильным визуальным присутствием, идеально подходящая для премиальных романтических и праздничных работ.",
    noteEn: "Bold red carnation with commanding depth.",
    noteRu: "Смелая красная гвоздика с выразительной глубиной.",
  },
  {
    id: "violet-pixel",
    name: "VIOLET PIXEL",
    image: "/images/new-varieties/violet-pixel.webp",
    descriptionEn:
      "A striking violet carnation with a textured finish and dramatic saturation, perfect for bold palettes and elevated design concepts.",
    descriptionRu:
      "Эффектная фиолетовая гвоздика с фактурной поверхностью и насыщенным цветом, идеально подходящая для смелых палитр и премиальных дизайнерских концепций.",
    noteEn: "Dramatic violet texture for standout palettes.",
    noteRu: "Эффектная фиолетовая фактура для ярких палитр.",
  },
  {
    id: "uyuni",
    name: "UYUNI",
    image: "/images/new-varieties/uyuni.webp",
    descriptionEn:
      "A pure white carnation with a soft central glow and balanced petal shape, offering freshness and versatility for sophisticated floral programs.",
    descriptionRu:
      "Чисто-белая гвоздика с мягким центральным свечением и гармоничной формой лепестков, дарящая свежесть и универсальность для изысканных цветочных программ.",
    noteEn: "Pure white elegance with soft luminosity.",
    noteRu: "Чистая белая элегантность с мягким свечением.",
  },
  {
    id: "siren",
    name: "SIREN",
    image: "/images/new-varieties/siren.webp",
    descriptionEn:
      "A delicate pink carnation with rounded volume and a luminous finish, ideal for graceful arrangements and romantic storytelling.",
    descriptionRu:
      "Нежно-розовая гвоздика с округлым объёмом и светящимся финишем, идеальная для изящных композиций и романтичной подачи.",
    noteEn: "Romantic pink bloom with soft fullness.",
    noteRu: "Романтичное розовое цветение с мягкой полнотой.",
  },
];

export const NEW_VARIETIES_URL =
  "https://tessacorporation.com/product-tag/new-in-varieties/";